/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const V6_FEATURE_FLAGS = {
  FLIGHTS_FEEDBACK_WIDGET: 'flights_feedback_enabled',
  FLIGHTS_POINTS_PLUS_CASH_ENABLED: 'flights_points_n_cash_enabled',
  FLIGHT_DETAILS_CARBON_EMISSION_URL: 'carbon_emmision_flights_enabled',
  FLIGHT_ENABLE_INSURANCE: 'flights_enable_insurance',
  FLIGHTS_ENABLE_CARBON_OFFSET: 'flights_enable_carbon_offset',
  FLIGHTS_ENABLE_FAST_PASS: 'flights_enable_fast_pass',
  FLIGHTS_ENABLE_SPECIAL_ASSISTANCE: 'flights_enable_special_assistance',
  FLIGHTS_ENABLE_MULTI_CURRENCY_SUPPORT_FARE_SUMMARY:
    'flights_enable_multi_currency_support_fare_summary',
  FLIGHTS_ENABLE_BIG_POINTS: 'flights_enable_big_points',
  FLIGHTS_SNAP_BUNDLE_ENABLED: 'flights_snap_bundle_enabled',
  FLIGHTS_THIN_LISTING_ENABLED: 'flights_thin_listing_enabled',
  /** JSON object of listing-page flags; keys in FLIGHTS_LISTING_PAGE_FLAG_KEYS. */
  FLIGHTS_LISTING_PAGE: 'flights_listing_page',
  FLIGHTS_MMB_FEATURE_FLAGS: 'flights_mmb_feature_flags',
  FLIGHTS_PORTAL_USAGE: 'flights_enable_portal_usage',
  flights_non_dotrez_baggage_pieces_enable:
    'flights_non_dotrez_baggage_pieces_enable',
} as const;

export const FLIGHTS_MMB_FEATURE_FLAG_KEYS = {
  INSURANCE: 'flights_enable_mmb_insurance',
  CARBON_OFFSET: 'flights_enable_mmb_carbon_offset',
  SPECIAL_ASSISTANCE: 'flights_enable_mmb_special_assistance',
  BAGGAGE: 'flights_enable_mmb_baggage',
  SEATS: 'flights_enable_mmb_seats',
  MEALS: 'flights_enable_mmb_meals',
  FAST_PASS: 'flights_enable_mmb_fast_pass',
  BUNDLE: 'flights_enable_mmb_bundle',
  PROMO_CODE: 'flights_enable_mmb_promo_code',
  SEAT_TOGETHER: 'flights_enable_mmb_seat_together',
} as const;

export type FlightsMmbFeatureFlags = Record<
  (typeof FLIGHTS_MMB_FEATURE_FLAG_KEYS)[keyof typeof FLIGHTS_MMB_FEATURE_FLAG_KEYS],
  boolean
>;

export const FLIGHTS_MMB_FEATURE_FLAGS_DEFAULT = Object.fromEntries(
  Object.values(FLIGHTS_MMB_FEATURE_FLAG_KEYS).map((key) => [key, false]),
) as FlightsMmbFeatureFlags;

/** Keys inside the `flights_listing_page` JSON setting. */
export const FLIGHTS_LISTING_PAGE_FLAG_KEYS = {
  CARD_V2: 'flights_card_v2_enabled',
  SEAT_AVAILABILITY: 'flights_seat_availability_enabled',
  BUNDLE_DISCOUNT: 'flights_bundle_discount_enabled',
  BUNDLE_AUTO_EXPAND: 'flights_bundle_auto_expand_enabled',
} as const;

export type FlightsListingPageFlags = Record<
  (typeof FLIGHTS_LISTING_PAGE_FLAG_KEYS)[keyof typeof FLIGHTS_LISTING_PAGE_FLAG_KEYS],
  boolean
>;

/** Every listing-page flag is off unless the setting turns it on. */
export const FLIGHTS_LISTING_PAGE_FLAGS_DEFAULT = Object.freeze(
  Object.fromEntries(
    Object.values(FLIGHTS_LISTING_PAGE_FLAG_KEYS).map((key) => [key, false]),
  ),
) as Readonly<FlightsListingPageFlags>;
